import { supabase } from '../supabase/supabase';

export const fetchAdminTaxRemittanceReport = async (startDate, endDate) => {
  const { data, error } = await supabase.rpc(
    'admin_get_tax_remittance_report_1793034000000',
    {
      p_start_date: startDate,
      p_end_date: endDate
    }
  );

  if (error) throw error;

  return data || {
    summary: {},
    transactions: [],
    start_date: startDate,
    end_date: endDate
  };
};